import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {BookingLogPayload} from '../types/BookingLogPayload';
import {EmailBookingPayload} from '../types/EmailBookingPayload';
import {ApiHelper} from './api.helper';
import {AppConfigService} from './app-config.service';

@Injectable()
export class EmailBookingService {
  constructor(private http: HttpClient, private apiHelper: ApiHelper, private appConfigService: AppConfigService) {}

  public SendBooking(booking: EmailBookingPayload): Observable<any> {
    return this.http
      .post(`${this.appConfigService.appConfig.apiUrl}Booking/CreateBookingRequest`, booking)
      .pipe(catchError((error) => this.apiHelper.handleError(error)));
  }

  public LogBooking(log: BookingLogPayload): Observable<any> {
    return this.http
      .post(`${this.appConfigService.appConfig.apiUrl}/booking/log`, log)
      .pipe(catchError((error) => this.apiHelper.handleError(error)));
  }
}
